import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class MountainsBlastFurnaceBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.MOUNTAINS_BLAST_FURNACE;
}

export default MountainsBlastFurnaceBuildingTileEntity;
